/* Pulse Region & Language Picker — toggle + flag emoji rendering */
(function () {
  'use strict';

  // Convert a 2-letter ISO 3166-1 alpha-2 country code (e.g. "US") into its emoji flag (🇺🇸).
  // Uses Unicode regional indicator symbols: A=U+1F1E6, B=U+1F1E7, etc.
  function isoToFlag(iso) {
    if (!iso || iso.length !== 2) return '';
    var base = 0x1F1A5; // regional indicator A is 0x1F1E6, so 'A'.charCodeAt(0) = 65; 0x1F1E6 - 65 = 0x1F1A5
    var up = iso.toUpperCase();
    return String.fromCodePoint(base + up.charCodeAt(0)) +
           String.fromCodePoint(base + up.charCodeAt(1));
  }

  function paintFlags(scope) {
    var root = scope || document;
    root.querySelectorAll('.pulse-region__flag[data-iso], .pulse-localebar__flag[data-iso], .pulse-footer__locale-flag[data-iso]').forEach(function (el) {
      if (el.textContent && el.textContent.trim().length > 0) return; // already painted
      el.textContent = isoToFlag(el.dataset.iso);
    });
  }

  // Close every other open region picker on the page (so only one panel is open at a time)
  function closeAllRegions(except) {
    document.querySelectorAll('[data-pulse-region]').forEach(function (r) {
      if (r === except) return;
      var p = r.querySelector('[data-pulse-region-panel]');
      var b = r.querySelector('[data-pulse-region-toggle]');
      if (p && !p.hidden) p.hidden = true;
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function bindRegion(region) {
    if (region.__pulseBound) return;
    region.__pulseBound = true;

    var btn = region.querySelector('[data-pulse-region-toggle]');
    var panel = region.querySelector('[data-pulse-region-panel]');
    if (!btn || !panel) return;

    function open() {
      // Close any other open picker first — only one open at a time
      closeAllRegions(region);
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) open(); else close();
    });

    document.addEventListener('click', function (e) {
      if (!region.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        close();
        btn.focus();
      }
    });
  }

  function init(scope) {
    paintFlags(scope);
    (scope || document).querySelectorAll('[data-pulse-region]').forEach(bindRegion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init when Shopify theme editor reloads a section that contains the picker
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-pulse-region]')) {
      init(e.target);
    }
  });
})();
